<template lang="jade">
  .container-fluid
    .row
      .m2m_main.col-md-12
        header.m2m_title_bar.main_title_bar.clearfix
          h1.title.col-md-12
            | Machine To Machine
        section.m2m_content.clearfix.row_space--xs
          section.m2m_tabs.col-md-10.col-centered
            tabs
              tab(header='M2M')
                table#m2m_table.table.table-striped.table-hover.table-bordered.hidden-xs
                  tr
                    th No.
                    th Name
                    th Detail
                    th Event
                    th Actions
                    th
                      i.fa.fa-plus-square
                  tr(v-for='detail in m2m_details')
                    td {{detail.id}}
                    td {{detail.name}}
                    td
                      p {{detail.detail}}
                    td {{detail.event}}
                    td.actions
                      .action(v-for='action in detail.actions')
                        span
                          i.fa.fa-edit
                        span {{action}}
                    td.function_group
                      .function__single
                        i.fa.fa-edit
                      .function__single
                        i.fa.fa-trash
                table#m2m_table_mobile.table.table-striped.table-bordered.visible-xs
                  tr
                    th No.
                    th Name
                    th
                  tr(v-for='(key, detail) in m2m_details')
                    td {{detail.id}}
                    td {{detail.name}}
                    td.function_group(v-on:click='handleShowM2M(key)')
                      .function__single
                        i.fa.fa-edit
                      .function__single.hidden
                        i.fa.fa-trash
              tab(header='Events')
                table#events_table.table.table-striped.table-hover.table-bordered.hidden-xs
                  tr
                    th No.
                    th Name
                    th Detail
                    th From Device
                    th Event
                    th
                      i.fa.fa-plus-square
                  tr(v-for='detail in events_details')
                    td {{detail.id}}
                    td {{detail.name}}
                    td
                      span {{detail.detail}}
                    td {{detail.device}}
                    td {{detail.event}}
                    td.function_group
                      .function__single
                        i.fa.fa-edit
                      .function__single
                        i.fa.fa-trash
                table#events_table_mobile.table.table-striped.table-bordered.visible-xs
                  tr
                    th No.
                    th Name
                    th
                  tr(v-for='(key, detail) in events_details')
                    td {{detail.id}}
                    td {{detail.name}}
                    td.function_group(v-on:click='handleShowEvents(key)')
                      .function__single
                        i.fa.fa-edit
                      .function__single.hidden
                        i.fa.fa-trash
              tab(header='Actions')
                table#actions_table.table.table-striped.table-hover.table-bordered.hidden-xs
                  tr
                    th No.
                    th Name
                    th Detail
                    th From Device
                    th Action
                    th
                      i.fa.fa-plus-square
                  tr(v-for='detail in actions_details')
                    td {{detail.id}}
                    td {{detail.name}}
                    td
                      span {{detail.detail}}
                    td {{detail.device}}
                    td {{detail.action}}
                    td.function_group
                      .function__single
                        i.fa.fa-edit
                      .function__single
                        i.fa.fa-trash
                table#actions_table_mobile.table.table-striped.table-bordered.visible-xs
                  tr
                    th No.
                    th Name
                    th
                  tr(v-for='(key,detail) in actions_details')
                    td {{detail.id}}
                    td {{detail.name}}
                    td.function_group(v-on:click='handleShowActions(key)')
                      .function__single
                        i.fa.fa-edit
                      .function__single.hidden
                        i.fa.fa-trash
              tab(header='E-mail')
                table#email_table.table.table-striped.table-hover.table-bordered.hidden-xs
                  tr
                    th No.
                    th Manage Group
                    th Email
                    th
                      i.fa.fa-plus-square
                  tr(v-for='detail in email_details')
                    td {{detail.id}}
                    td {{detail.group}}
                    td
                      p(v-for='email in detail.emails') {{email}}
                    td.function_group
                      .function__single
                        i.fa.fa-edit
                      .function__single
                        i.fa.fa-trash
                table#email_table_mobile.table.table-striped.table-bordered.visible-xs
                  tr
                    th No.
                    th Manage Group
                    th
                  tr(v-for='(key,detail) in email_details')
                    td {{detail.id}}
                    td {{detail.group}}
                    td.function_group(v-on:click='handleShowEmail(key)')
                      .function__single
                        i.fa.fa-edit
                      .function__single.hidden
                        i.fa.fa-trash
              tab(header='SMS')
                table#SMS_table.table.table-striped.table-hover.table-bordered.hidden-xs
                  tr
                    th No.
                    th Manage Group
                    th Phone Number
                    th
                      i.fa.fa-plus-square
                  tr(v-for='detail in SMS_details')
                    td {{detail.id}}
                    td {{detail.group}}
                    td
                      p(v-for='phone in detail.phones')
                       |{{phone}}
                    td.function_group
                      .function__single
                        i.fa.fa-edit
                      .function__single
                        i.fa.fa-trash
                table#SMS_table_mobile.table.table-striped.table-bordered.visible-xs
                  tr
                    th No.
                    th Manage Group
                    th
                  tr(v-for='(key,detail) in SMS_details')
                    td {{detail.id}}
                    td {{detail.group}}
                    td.function_group(v-on:click='handleShowSMS(key)')
                      .function__single
                        i.fa.fa-edit
                      .function__single.hidden
                        i.fa.fa-trash
      modal.popout_m2m_config.config_table(
        v-bind:show.sync='showM2M'
        v-bind:title='editing.title'
        effect='zoom'
        v-bind:callback=''
        ok-text="Apply"
        cancel-text="Cancel")
        .modal-body(slot="modal-body")
          .table-responsive
            table#m2m_table_config.table.table-bordered
              tr(v-for='(key, value) in editing.m2m')
                th {{key}}
                td
                  p {{value}}
      modal.popout_events_config.config_table(
        v-bind:show.sync='showEvents'
        v-bind:title='editing.title'
        effect='zoom'
        v-bind:callback=''
        ok-text="Apply"
        cancel-text="Cancel")
        .modal-body(slot="modal-body")
          .table-responsive
            table#events_table_config.table.table-bordered
              tr(v-for='(key, value) in editing.events')
                th {{key}}
                td
                  p {{value}}
      modal.popout_actions_config.config_table(
        v-bind:show.sync='showActions'
        v-bind:title='editing.title'
        effect='zoom'
        v-bind:callback=''
        ok-text="Apply"
        cancel-text="Cancel")
        .modal-body(slot="modal-body")
          .table-responsive
            table#actions_table_config.table.table-bordered
              tr(v-for='(key, value) in editing.actions')
                th {{key}}
                td
                  p {{value}}
      modal.popout_email_config.config_table(
        v-bind:show.sync='showEmail'
        v-bind:title='editing.title'
        effect='zoom'
        v-bind:callback=''
        ok-text="Apply"
        cancel-text="Cancel")
        .modal-body(slot="modal-body")
          .table-responsive
            table#email_table_config.table.table-bordered
              tr(v-for='(key, value) in editing.email')
                th {{key}}
                td.value
                  p {{value}}
      modal.popout_SMS_config.config_table(
        v-bind:show.sync='showSMS'
        v-bind:title='editing.title'
        effect='zoom'
        v-bind:callback=''
        ok-text="Apply"
        cancel-text="Cancel")
        .modal-body(slot="modal-body")
          .table-responsive
            table#SMS_table_config.table.table-bordered
              tr(v-for='(key, value) in editing.SMS')
                th {{key}}
                td
                  p {{value}}
</template>
<script>
import { tab, modal } from 'vue-strap'
import tabset from 'src/components/Tabset.vue'
import _ from 'lodash'
export default {
  components: {
    modal,
    tab,
    'tabs': tabset
  },
  data () {
    return {
      showM2M: false,
      showEvents: false,
      showActions: false,
      showEmail: false,
      showSMS: false,
      editing: {
        title: '',
        m2m: {},
        events: {},
        actions: {},
        email: {},
        SMS: {}
      },
      m2m_details: [
        {
          id: '1',
          name: 'Matrix failover',
          detail: 'Reset matrix\'s power if disconnected',
          event: 'Matrix disconnected',
          actions: ['Power reset']
        },
        {
          id: '2',
          name: 'DVD protect',
          detail: 'When DVD over-current, POW-1109 will power off bank1, then power on bank3. Finally 5588-H will remap from DVD to PS4.',
          event: 'DVD over-current',
          actions: ['Matrix remapping', 'DVD power off', 'PS4 power on']
        }
      ],
      events_details: [
        {
          id: '1',
          name: 'Matrix failover',
          detail: 'A11-8F Control Room',
          device: '5588-H',
          event: 'Connection === OFF'
        },
        {
          id: '2',
          name: 'DVD over-current',
          detail: 'A11-B1F Power Center',
          device: 'POW-109',
          event: 'Current >= 3A of Bank1'
        }
      ],
      actions_details: [
        {
          id: '1',
          name: 'Matrix remapping',
          detail: 'A11-8F Control Room',
          device: '5588-H',
          action: 'Remapping (output1, output2)'
        },
        {
          id: '2',
          name: 'Power reset',
          detail: 'A11-B1F Power Center',
          device: 'POW-109',
          action: 'Power RESET at Bank1'
        },
        {
          id: '3',
          name: 'DVD power off',
          detail: 'A11-B1F Power Center',
          device: 'POW-109',
          action: 'Power OFF at Bank2'
        },
        {
          id: '4',
          name: 'PS4 power on',
          detail: 'A11-B1F Power Center',
          device: 'POW-109',
          action: 'Power ON at Bank3'
        }
      ],
      email_details: [
        {
          id: '1',
          group: 'Admin',
          emails: [
            'admin@gmail.com',
            'intrising@gmail.com'
          ]
        },
        {
          id: '2',
          group: 'Mis',
          emails: [
            'mis@gmail.com',
            'joe@gmail.com'
          ]
        }
      ],
      SMS_details: [
        {
          id: '1',
          group: 'Admin',
          phones: [
            '+886-972123456'
          ]
        },
        {
          id: '2',
          group: 'Manager',
          phones: [
            '+886-932123456',
            '+886-012123456'
          ]
        }
      ]
    }
  },
  asyncData () {
  },
  computed: {
  },
  methods: {
    handleShowM2M (key) {
      this.editing.m2m = _.cloneDeep(this.m2m_details[key])
      this.editing.title = 'M2M ' + this.editing.m2m.id + ' Config'
      this.showM2M = true
    },
    handleShowEvents (key) {
      this.editing.events = _.cloneDeep(this.events_details[key])
      this.editing.title = 'Event ' + this.editing.events.id + ' Config'
      this.showEvents = true
    },
    handleShowActions (key) {
      this.editing.actions = _.cloneDeep(this.actions_details[key])
      this.editing.title = 'Actions ' + this.editing.actions.id + ' Config'
      this.showActions = true
    },
    handleShowEmail (key) {
      this.editing.email = _.cloneDeep(this.email_details[key])
      this.editing.title = 'Email ' + this.editing.email.id + ' Config'
      this.showEmail = true
    },
    handleShowSMS (key) {
      this.editing.SMS = _.cloneDeep(this.SMS_details[key])
      this.editing.title = 'SMS ' + this.editing.SMS.id + ' Config'
      this.showSMS = true
    }
  }, // close methods
  ready () {
  },
  watch: {
  }
}
</script>
<style lang="scss" scoped>
@import '~__vendor_variables_scss__';
@import '~sass/_breakpoint.scss';
table{
  th,td{
    text-align:center;
  }
  th{
    font-size: 20px;
    text-transform:capitalize;
    @include breakpoint(xs) {
      font-size: 14px;
    }
  }
  .fa{
    cursor:pointer;
  }
}
.title{
  @include breakpoint(xs) {
    font-size: 16px;
  }
}
#m2m_table{
  tr:first-child{
    th:nth-child(1){
      width:5%;
    }
    th:nth-child(2){
      width:15%;
    }
    th:nth-child(3){
      width:30%;
    }
  }
  // td.actions
  .actions {
    text-align:left;
    padding-left:15px;
    .fa{
      margin-right: 5px;
    }
  }
}// close #m2m_table


#m2m_table, #events_table, #actions_table, #email_table, #SMS_table{
  // functions
  tr{
    .function__single{
      display:none;
    }
    &:hover{
      .function__single{
        display:inline-block;
      }
    }
  }
  .function_group{
    width: 60px;
    padding:5px 0px 0px 0px;
  }
  .function__single{
    display:inline-block;
    width: 20px;
    font-size: 20px;
  }
} // close #event_table


// ======= config table settings =================
#email_table_config{
  table-layout:fixed;
  .value{
    overflow-x:scroll;
  }
}

@include breakpoint(xs) {
  .config_table{
    table{
      table-layout:fixed;
    }

    th{
      width:30%;
      font-size: 14px;
    }
    td{
      p{
        font-size: 12px;
      }
      width:70%;
      overflow-x:scroll;
    }
  }
}


</style>



// WEBPACK FOOTER //
// M2M.vue?379ede22